import { Box } from "@material-ui/core";
import React from "react";
import { PackageHotelPriceAndRewardsDisplay } from "halifax";
import { AVAILABLE, getExperimentVariant } from "@capone/experiments";
import { SelectedPackagePricingCardConnectorProps } from "./container";
import "./styles.scss";
import {
  PACKAGES_LIST_OPTIMIZATIONS_V1,
  useExperiments,
} from "../../../../../context/experiments";
import { getConfigTenant, isCorpTenant } from "@capone/common";

interface ISelectedPackagePricingCard
  extends SelectedPackagePricingCardConnectorProps {
  isMobile?: boolean;
}

export const SelectedPackagePricingCard = (
  props: ISelectedPackagePricingCard,
) => {
  const {
    selectedPackageByLodging,
    rewardsKey,
    packageNightCountBasedOnAvailability,
    packageNightCountBasedOnOutboundFlight,
    travelersCount,
    selectedPackageByOutboundFlight,
    isMobile,
    selectedLodging,
  } = props;
  if (!selectedPackageByLodging) return null;

  const expState = useExperiments();
  const packagesListEnhancementsEnabled =
    getExperimentVariant(
      expState.experiments,
      PACKAGES_LIST_OPTIMIZATIONS_V1,
    ) === AVAILABLE;

  const pricing =
    selectedPackageByOutboundFlight?.pricing ??
    selectedPackageByLodging.packageDetails?.pricing;
  const nightCount =
    packageNightCountBasedOnOutboundFlight ??
    packageNightCountBasedOnAvailability;

  return (
    <Box className="selected-package-pricing-card-root">
      <PackageHotelPriceAndRewardsDisplay
        pricing={pricing}
        nightCount={nightCount}
        travelersCount={travelersCount}
        rewardsKey={rewardsKey}
        isMobile={isMobile}
        showEnhancedUI={packagesListEnhancementsEnabled}
        showOffer={isCorpTenant(getConfigTenant())}
        bestOfferThisLodging={selectedLodging?.bestOfferThisLodging}
      />
    </Box>
  );
};
